import React from 'react'

const SuitCaseIcon = ({ color = '#CCCFD6' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
    <path d="M2.45312 19C1.90313 19 1.43229 18.8042 1.04063 18.4125C0.648958 18.0208 0.453125 17.55 0.453125 17V6C0.453125 5.45 0.648958 4.97917 1.04063 4.5875C1.43229 4.19583 1.90313 4 2.45312 4H6.45312V2C6.45312 1.45 6.64896 0.979167 7.04063 0.5875C7.43229 0.195833 7.90312 0 8.45312 0H12.4531C13.0031 0 13.474 0.195833 13.8656 0.5875C14.2573 0.979167 14.4531 1.45 14.4531 2V4H18.4531C19.0031 4 19.474 4.19583 19.8656 4.5875C20.2573 4.97917 20.4531 5.45 20.4531 6V17C20.4531 17.55 20.2573 18.0208 19.8656 18.4125C19.474 18.8042 19.0031 19 18.4531 19H2.45312ZM8.45312 4H12.4531V2H8.45312V4ZM18.4531 13H13.4531V15H7.45312V13H2.45312V17H18.4531V13ZM9.45312 13H11.4531V11H9.45312V13ZM2.45312 11H7.45312V9H13.4531V11H18.4531V6H2.45312V11Z" fill={color}/>
    </svg>
  )
}

export default SuitCaseIcon

//mask="url(#mask0_117_21276)"
